import React from 'react';
import Wrapper from './StyledPage';

export const Monitoring = () => {
  return <Wrapper>Monitoring</Wrapper>;
};
